import React from "react";
import { Container, Row, Col } from "shards-react";
import Quote from "../components/common/bookings/Quote";

const BookingQuoteView = props => {
  const { id } = props.match.params;
  return (
    <Container fluid className="main-content-container px-4">
      <Quote id={id} />
    </Container>
  );
};

export default BookingQuoteView;
